module.exports = __webpack_public_path__ + "img/cn_pocket-18.d00d9c5.jpg";